/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TagType {
  Counter = 'Counter',
  Date = 'Date',
  MultiLineString = 'MultiLineString',
  Number = 'Number',
  Selection = 'Selection',
  SingleLineString = 'SingleLineString',
  UserSelection = 'UserSelection',
  DocumentType = 'DocumentType',
  DocumentName = 'DocumentName'
}
